import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const menuItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About BB Global Financial Administration' },
    { id: 'how-we-support', label: 'How We Support' },
    { id: 'services', label: 'Services' },
    { id: 'global', label: 'Where We Are' },
    { id: 'contact', label: 'Get in Touch' },
    { id: 'references', label: 'References' },
  ];

  const scrollToSection = (id: string) => {
    setMobileOpen(false);

    if (id === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = 80;
      const elementTop = element.getBoundingClientRect().top + window.scrollY;
      const targetY = elementTop - navbarHeight;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
      style={{ height: '80px' }}
    >
      <div className="w-full px-6 lg:px-12 h-full flex items-center">
        <div className="flex items-center justify-between w-full">
          <a
            href="#home"
            onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
            className="flex items-center space-x-3 cursor-pointer"
          >
            <img
              src="https://storage.readdy-site.link/project_files/11bf54dc-cd8b-412f-9383-b1020052ccc0/e790e585-9341-4eda-8466-7e9d89aa3fd5_ChatGPT-Image-Mar-2-2026-12_02_26-PM-ek.png?v=e86025dbcd928cb45795c7555e605914"
              alt="BB Beyhan Balance Logo"
              className="h-14 w-auto object-contain"
            />
          </a>

          <div className="hidden lg:flex items-center space-x-5">
            {menuItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => { e.preventDefault(); scrollToSection(item.id); }}
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-700 hover:text-ocean-mid' : 'text-white/90 hover:text-white drop-shadow-md'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden cursor-pointer ${scrolled ? 'text-ocean-mid' : 'text-white drop-shadow-lg'}`}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-ocean-pale px-6 py-6 space-y-4 shadow-xl">
          {menuItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => { e.preventDefault(); scrollToSection(item.id); }}
              className="block text-ocean-mid hover:text-sunset-coral font-medium transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
